module.exports = "/static/assets/a510e2c02febcade2ecc23aa5a96cbd9.png";